import React, { ChangeEvent, forwardRef } from 'react';

import './text-area.scss';

interface Props {
	label: string;
	handleChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
	value: string;
	placeholder: string;
	isError?: boolean;
	row?: number;
	disable?: boolean;
	id?: string;
	inputName?: string
	onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

/**
 * TextArea component
 *
 * @param {string} Props.label - Label for the text area
 * @param {(e: ChangeEvent<HTMLTextAreaElement>) => void} Props.handleChange - Callback function to handle text area value change
 * @param {string} Props.value - Current value of the text area
 * @param {string} Props.placeholder - Placeholder text for the text area
 * @param {boolean} Props.isError - Flag indicating whether there is an error in the text area
 * @param {number} Props.row - Number of rows for the text area
 * @param {boolean} Props.disable - Flag indicating whether the text area is disabled
 * @param {Function} Props.onKeyDown - Optional keyboard event handler
 * @param {React.Ref<HTMLTextAreaElement>} ref - Optional ref for the textarea element
 */

const TextAreaComponent = forwardRef<HTMLTextAreaElement, Props>(({
	label,
	handleChange,
	value,
	placeholder,
	isError = false,
	row = 6,
	disable = false,
	id = '',
	inputName="some area",
	onKeyDown
}, ref) => {
	return (
		<div className="input">
			<div className="input__label">{label}</div>
			<div
				className={`input__text-field input__text-field${
					isError ? '--error' : ''
				}`}
			>
				<textarea
					name={inputName}
					className="input__field text-area-fieldd"
					rows={row}
					value={value}
					placeholder={placeholder}
					onChange={handleChange}
					disabled={disable}
					id={id}
					onKeyDown={onKeyDown}
					ref={ref}
				/>
			</div>
		</div>
	);
});

TextAreaComponent.displayName = 'TextArea';

export const TextArea = TextAreaComponent;
